// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';
import { formatDate } from 'helpers/smallCodes';
import { colorAndLabelDecider } from 'layouts/purchases/helpers/general';
import PrintIcon from '@mui/icons-material/Print';

function Header({ orderNumber, orderDate, customerName, onPrint }) {
    return (
        <MDBox
            sx={{
                background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                border: '1px solid #e2e8f0',
                borderRadius: '16px',
                padding: '24px',
                boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                position: 'relative',
                overflow: 'hidden',
                marginBottom: '24px',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    height: '4px',
                    background: 'linear-gradient(90deg, #10B981, #059669)',
                    borderRadius: '16px 16px 0 0',
                },
            }}
        >
            <MDBox display="flex" justifyContent="space-between" alignItems="center">
                <MDBox flex={1}>
                    <MDBox mb={2} display="flex" alignItems="center">
                        <MDBox
                            sx={{
                                width: '32px',
                                height: '32px',
                                backgroundColor: '#10B981',
                                borderRadius: '8px',
                                marginRight: '12px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                boxShadow: '0 2px 4px rgba(16, 185, 129, 0.3)',
                            }}
                        >
                            <MDTypography sx={{ color: 'white', fontSize: '16px', fontWeight: 'bold' }}>
                                📋
                            </MDTypography>
                        </MDBox>
                        <MDTypography
                            variant="h5"
                            fontWeight="bold"
                            component="a"
                            href={`https://ahsaplar.com/wp-admin/post.php?post=${orderNumber}&action=edit`}
                            target="_blank"
                            rel="noopener noreferrer"
                            sx={{
                                cursor: 'pointer',
                                textDecoration: 'none',
                                color: '#1f2937',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    color: '#10B981',
                                    transform: 'translateX(4px)',
                                },
                            }}
                        >
                            Sipariş #{orderNumber}
                        </MDTypography>
                    </MDBox>

                    <MDBox display="flex" gap={3} flexWrap="wrap">
                        <MDBox
                            sx={{
                                backgroundColor: '#f0fdf4',
                                border: '1px solid #bbf7d0',
                                borderRadius: '8px',
                                padding: '8px 12px',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <MDTypography sx={{ fontSize: '14px', marginRight: '6px' }}>📅</MDTypography>
                            <MDTypography variant="caption" sx={{ color: '#059669', fontWeight: '600' }}>
                                {formatDate(orderDate)}
                            </MDTypography>
                        </MDBox>

                        <MDBox
                            sx={{
                                backgroundColor: '#eff6ff',
                                border: '1px solid #bfdbfe',
                                borderRadius: '8px',
                                padding: '8px 12px',
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            <MDTypography sx={{ fontSize: '14px', marginRight: '6px' }}>👤</MDTypography>
                            <MDTypography variant="caption" sx={{ color: '#1e40af', fontWeight: '600' }}>
                                {customerName}
                            </MDTypography>
                        </MDBox>
                    </MDBox>
                </MDBox>

                <MDBox>
                    <MDBox display="flex" gap={2} alignItems="center">
                        {/* Yazdır Butonu */}
                        <MDButton
                            variant="outlined"
                            color="info"
                            size="medium"
                            startIcon={<PrintIcon />}
                            onClick={onPrint}
                            sx={{
                                borderColor: '#3B82F6',
                                color: '#3B82F6',
                                fontWeight: '600',
                                fontSize: '0.875rem',
                                padding: '8px 16px',
                                borderRadius: '8px',
                                transition: 'all 0.3s ease',
                                '&:hover': {
                                    backgroundColor: '#3B82F6',
                                    color: 'white',
                                    transform: 'translateY(-1px)',
                                    boxShadow: '0 4px 8px rgba(59, 130, 246, 0.3)',
                                },
                            }}
                        >
                            Yazdır
                        </MDButton>

                        {/* Durum Butonu */}
                        {(() => {
                            const { color, label } = colorAndLabelDecider(orderDate);
                            return (
                                <MDButton
                                    variant="gradient"
                                    color={color}
                                    size="large"
                                    sx={{
                                        background:
                                            color === 'success'
                                                ? 'linear-gradient(135deg, #10B981, #059669)'
                                                : color === 'warning'
                                                ? 'linear-gradient(135deg, #F59E0B, #D97706)'
                                                : color === 'error'
                                                ? 'linear-gradient(135deg, #EF4444, #DC2626)'
                                                : 'linear-gradient(135deg, #3B82F6, #1D4ED8)',
                                        color: 'white',
                                        fontWeight: '600',
                                        fontSize: '0.875rem',
                                        padding: '12px 24px',
                                        borderRadius: '12px',
                                        boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
                                        transition: 'all 0.3s ease',
                                        '&:hover': {
                                            transform: 'translateY(-2px)',
                                            boxShadow: '0 8px 15px -3px rgba(0, 0, 0, 0.1)',
                                        },
                                    }}
                                >
                                    {label}
                                </MDButton>
                            );
                        })()}
                    </MDBox>
                </MDBox>
            </MDBox>
        </MDBox>
    );
}

export default Header;
